import { useCallback } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ImageUtils from "../../../../../utils/ReUsableComponents/ImageUtils";
// import MostSearchedKeywords from "./MostSearchedKeywords";

const SmallAndSquareMaerskModel = (props) => {
    const imageUtil = new ImageUtils();
    const business = props.maserskmodel?.maerskmodelData;
    const title = props.name;

    return (
        <>
            <div className="biz-dom-wrap py-4">
                <Row >
                    <Col xxl={12} lg={12} xl={12} md={12}>
                        {title && (
                            <div>
                                <p className="do__bu__tag">
                                    {title} ({props.maserskmodel?.maerskmodelData?.length})
                                </p>
                            </div>
                        )}
                        <Row className="gy-3">
                            {business.map((d, index) => {
                                const catdatas = {
                                    tag: props.tag,
                                    value: d.key,
                                };
                                return (
                                    <Col sm={6} md={4} lg={4} xl={3} xxl={2} key={index}>
                                        {" "}
                                        <Link
                                            to={`/databook/${props.tag}/${d.key}`}
                                            className="widg__f"
                                            state={catdatas}
                                        >
                                            <Card className="h-100 shadow-none border rounded-1">
                                                <Card.Body className="bg-transparent rounded-1">
                                                    <div className="main__b">
                                                        {/* <span role="img" className="img__b">
                                                            <img
                                                                src={imageUtil.getImage(d.key)}
                                                                alt="business-cards"
                                                            />
                                                        </span>
                                                        <span className="sub__b">
                                                            <span className="bd__name text-wrap">{d.key}</span>
                                                            <h5 className="bd__val">{d.value}</h5>
                                                        </span> */}

                                                        <div>
                                                            <div className="card_label"><span className="bd__name text-wrap">{d.key}</span></div>
                                                            <div className="card_count"><h5 className="bd__val">{d.value}</h5></div>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Col>
                    {/* <MostSearchedKeywords wordCloudData={props.maserskmodel?.keywordCloudData} /> */}
                </Row>
            </div>
        </>
    );
};

export default SmallAndSquareMaerskModel;
